import { render, staticRenderFns } from "./dialogueTool.vue?vue&type=template&id=22c85a32&scoped=true&"
import script from "./dialogueTool.vue?vue&type=script&lang=js&"
export * from "./dialogueTool.vue?vue&type=script&lang=js&"
import style0 from "./dialogueTool.vue?vue&type=style&index=0&id=22c85a32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c85a32",
  null
  
)

export default component.exports